import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TitleService } from '@fmnts/common/browser';

@Component({
  imports: [RouterModule],
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class SupporterFeedbackAppComponent {
  constructor() {
    const titleService = inject(TitleService);
    titleService.setSuffix('Feedback');
    titleService.setTitle();
  }
}
